export default {
  homepage: {
    topDealsTag: "4815d07b-f344-43e8-907c-eeb97d2852c4",
    topDeals: "Las mejores ofertas del día",
    currentDealsTitle: "Ofertas actuales",
    currentDealsSubline:
      "Aquí encontrarás de un vistazo, todas las ofertas disponibles",
    buttonText: "A las ofertas",

    tagSection_1_tagImage: "/assets/images/home-mood/destination_spain",
    tagSection_1_tagId: "887a4192-9528-4402-b5af-54f7e9eaa4c0",
    tagSection_1_title: "Vacaciones por España",
    tagSection_1_subline: "Las mejores ofertas para viajar cerca de casa",

    tagSection_2_tagImage: "/assets/images/home-mood/tag_flexcancel",
    tagSection_2_tagId: "a1848aaf-fc76-46b4-83ee-8d764b4ed4ee",
    tagSection_2_title: "Viajes con cancelación gratuita",
    tagSection_2_subline:
      "Ofertas con buenas condiciones de cancelación y cambios de reserva",

    tagSection_3_tagImage: "/assets/images/home-mood/tag_hotels",
    tagSection_3_tagId: "0f3be86e-579d-42d9-9d88-c9d722f2ad4f",
    tagSection_3_title: "Último minuto",
    tagSection_3_subline: "Las mejores ofertas para escapadas cortas",

    partnerSection_link: "https://hoteles.holidayguru.es/",
    partnerSection_title: "Comparador de hoteles",
    partnerSection_subline: "El alojamiento que necesitas",
    noMoreDealsInfo: "no hay más ofertas disponibles",

    promotionSection_title: "Black Week",
    promotionSection_subline:
      "Las mejores ofertas de viajes en Buscounchollo.com de la Black Week 2020",
    promotionSection_link: "https://www.holidayguru.es/?p=248971",
    promotionSection_button: "Descubre Más"
  },
  supportPersonImageSrc: "/assets/images/callcenter/maria.jpg",

  magazine: {
    section: {
      link: "https://www.holidayguru.es/revista-de-viajes/",
      image: "/assets/images/magazine/es.jpg"
    }
  },

  raffle: {
    link: "https://www.holidayguru.es/sorteo-semana-santa-viaje-creta/"
  },

  partnerList: {
    headline: "Otro tipo de viajes",
    subline: "Las vacaciones que necesitas",
    data: [
      {
        label: "Vuelos + hotel",
        sub: "Escapadas con vuelos y hotel",
        url: "https://viajes.holidayguru.es/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png"
      },
      {
        label: "Hoteles",
        sub: "El alojamiento perfecto",
        url: "https://hoteles.holidayguru.es/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_hotels.png"
      },
      {
        label: "Vuelos",
        sub: "Vuelos baratos a cualquier parte del mundo",
        url: "https://www.holidayguru.es/buscador-de-vuelos/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fluege.png"
      },
      {
        label: "Último minuto",
        sub: "Ofertas de último minuto al mejor precio",
        url: "https://www.holidayguru.es/ofertas-ultimo-minuto/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png"
      },
      {
        label: "Apartamentos y casas",
        sub: "Vacaciones con la máxima comodidad",
        url: "https://prf.hn/click/camref:1011l9qeH",
        image: "/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png"
      },
      {
        label: "Cruceros",
        sub: "Cruceros con wellness, piscina, eventos y mucho más",
        url: "https://cruceros.holidayguru.es/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kreuzfahrten.png"
      },
      {
        label: "Ofertas de esquí",
        sub: "Vacaciones en la nieve al mejor precio",
        url: "https://viajesesqui.holidayguru.es/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_skireisen.png"
      },
      {
        label: "Coches de alquiler",
        sub: "Comparador de coches de alquiler",
        url: "https://www.holidayguru.es/alquiler-de-coches/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png"
      }
    ]
  },

  linkList: [
    {
      label: "Los destinos más populares",
      links: [
        {
          label: "Viajes por España",
          url: "https://www.holidayguru.es/destinos/espana/"
        },
        {
          label: "Viajes a Mallorca",
          url: "https://www.holidayguru.es/destinos/mallorca/"
        },
        {
          label: "Viajes a Islas Canarias",
          url: "https://www.holidayguru.es/destinos/canarias/"
        },
        {
          label: "Viajes a Ibiza",
          url: "https://www.holidayguru.es/destinos/ibiza/"
        },
        {
          label: "Viajes a Tenerife",
          url: "https://www.holidayguru.es/destinos/tenerife/"
        },
        {
          label: "Viajes a Andalucía",
          url: "https://www.holidayguru.es/destinos/andalucia/"
        },
        {
          label: "Viajes a Menorca",
          url: "https://www.holidayguru.es/destinos/menorca/"
        }
      ]
    },
    {
      label: "Viajes al extranjero",
      links: [
        {
          label: "Viajes a Andorra",
          url: "https://www.holidayguru.es/destinos/andorra/"
        },
        {
          label: "Viajes a Cuba",
          url: "https://www.holidayguru.es/tag/cuba/"
        },
        {
          label: "Viajes a Marruecos",
          url: "https://www.holidayguru.es/tag/marruecos/"
        },
        {
          label: "Viajes a Islandia",
          url: "https://www.holidayguru.es/tag/islandia/"
        },
        {
          label: "Viajes a México",
          url: "https://www.holidayguru.es/tag/mexico/"
        },
        {
          label: "Viajes a Tailandia",
          url: "https://www.holidayguru.es/tag/tailandia/"
        },
        {
          label: "Viajes a Dubái",
          url: "https://www.holidayguru.es/destinos/dubai/"
        }
      ]
    },
    {
      label: "Destinos de playa",
      links: [
        {
          label: "Viajes a las Islas Griegas",
          url: "https://www.holidayguru.es/destinos/islas-griegas/"
        },
        {
          label: "Viajes a Cerdeña",
          url: "https://www.holidayguru.es/tag/cerdena/"
        },
        {
          label: "Viajes a Malta",
          url: "https://www.holidayguru.es/tag/malta/"
        },
        {
          label: "Viajes a Portugal",
          url: "https://www.holidayguru.es/destinos/portugal/"
        },
        {
          label: "Viajes a Italia",
          url: "https://www.holidayguru.es/tag/italia/"
        },
        {
          label: "Viajes a Turquía",
          url: "https://www.holidayguru.es/tag/turquia/"
        },
        {
          label: "Viajes a Túnez",
          url: "https://www.holidayguru.es/tag/tunez/"
        }
      ]
    },
    {
      label: "Destinos de ciudad",
      links: [
        {
          label: "Viajes a Barcelona",
          url: "https://www.holidayguru.es/destinos/barcelona/"
        },
        {
          label: "Viajes a Madrid",
          url: "https://www.holidayguru.es/destinos/madrid/"
        },
        {
          label: "Viajes a Amsterdam",
          url: "https://www.holidayguru.es/destinos/amsterdam/"
        },
        {
          label: "Viajes a Londres",
          url: "https://www.holidayguru.es/destinos/londres/"
        },
        {
          label: "Viajes a Roma",
          url: "https://www.holidayguru.es/destinos/roma/"
        },
        {
          label: "Viajes a Nueva York",
          url: "https://www.holidayguru.es/destinos/nueva-york/"
        }
      ]
    },
    {
      label: "Tipos de viajes",
      links: [
        {
          label: "Hoteles",
          url: "https://www.holidayguru.es/hoteles/"
        },
        {
          label: "Vuelos",
          url: "https://www.holidayguru.es/vuelos/"
        },
        {
          label: "Vuelos y hotel",
          url: "https://www.holidayguru.es/tag/vuelos-y-hotel/"
        },
        {
          label: "Paquetes vacacionales",
          url: "https://www.holidayguru.es/tag/vacaciones/"
        },
        {
          label: "Última hora",
          url: "https://www.holidayguru.es/ofertas-ultimo-minuto/"
        },
        {
          label: "Todo Incluido",
          url: "https://www.holidayguru.es/tag/hoteles-todo-incluido/"
        },
        {
          label: "Viajes con cancelación gratuita",
          url: "https://www.holidayguru.es/viajes-con-cancelacion-gratuita/"
        }
      ]
    },
    {
      label: "Especial",
      links: [
        {
          label: "Circuitos",
          url: "https://www.holidayguru.es/circuitos/"
        },
        {
          label: "Cruceros",
          url: "https://www.holidayguru.es/tag/cruceros/"
        },
        {
          label: "Ofertas Disneyland",
          url: "https://www.holidayguru.es/tag/disneyland-paris/"
        },
        {
          label: "Ofertas Warner Madrid",
          url: "https://www.holidayguru.es/tag/ofertas-warner/"
        },
        {
          label: "Vacaciones con niños",
          url: "https://www.holidayguru.es/vacaciones-con-ninos/"
        },
        {
          label: "Vacaciones de verano",
          url: "https://www.holidayguru.es/vacaciones-verano/"
        }
      ]
    },
    {
      label: "Escapadas",
      links: [
        {
          label: "Escapadas fin de semana",
          url: "https://www.holidayguru.es/escapadas-fin-de-semana/"
        },
        {
          label: "Escapadas en grupo",
          url: "https://www.holidayguru.es/viajes-en-grupo-baratos/"
        },
        {
          label: "Escapadas románticas",
          url: "https://www.holidayguru.es/escapada-romantica/"
        },
        {
          label: "Escapada rural",
          url: "https://www.holidayguru.es/escapadas-rurales/"
        },
        {
          label: "Hoteles con bañera hidromasaje",
          url: "https://www.holidayguru.es/hoteles-con-banera-hidromasaje/"
        },
        {
          label: "Hoteles con spa",
          url: "https://www.holidayguru.es/ofertas-spa/"
        },
        {
          label: "Escapadas Nochevieja",
          url: "https://www.holidayguru.es/calendario-de-viajes/nochevieja/"
        }
      ]
    },
    {
      label: "Más información",
      links: [
        {
          label: "Destinos",
          url: "https://www.holidayguru.es/destinos/"
        },
        {
          label: "Busca y reserva",
          url: "https://www.holidayguru.es/busca-y-reserva/"
        },
        {
          label: "Dónde viajar según el mes",
          url: "https://www.holidayguru.es/calendario-de-viajes/donde-viajar-cada-mes/"
        },
        {
          label: "Calendario de puentes",
          url: "https://www.holidayguru.es/calendario-de-puentes/"
        },
        {
          label: "Mejor época para viajar según el destino",
          url: "https://www.holidayguru.es/calendario-de-viajes/mejor-epoca-para-viajar-a-los-mejores-destinos/"
        }
      ]
    }
  ],

  footer: {
    corporate: {
      label: "Empresa",
      data: [
        {
          label: "Sobre Holidayguru",
          url: "https://www.holidayguru.es/sobre-mi/"
        },
        {
          label: "Prensa",
          url: "https://www.holidayguru.es/prensa/"
        },
        {
          label: "Trabaja con nosotros",
          url: "https://www.urlaubsguru.de/jobs/"
        },
        {
          label: "App",
          url: "https://www.holidayguru.es/app/"
        }
      ]
    },
    informations: {
      label: "Información",
      data: [
        {
          label: "Preguntas frecuentes",
          url: "https://www.holidayguru.es/preguntas-frecuentes-holidayguru/"
        },
        {
          label: "Revista de viajes",
          url: "https://www.holidayguru.es/revista-de-viajes/"
        },
        {
          label: "Escapadas rurales",
          url: "https://www.holidayguru.es/escapadas-rurales/"
        },
        {
          label: "Restricciones de viaje Covid-19",
          url: "https://www.holidayguru.es/revista-de-viajes/coronavirus-por-paises/"
        }
      ]
    },
    buttons: [
      {
        label: "Política de privacidad",
        url: "https://www.holidayguru.es/politica-de-privacidad/"
      },
      {
        label: "Aviso legal/Referencias jurídicas",
        url: "https://www.holidayguru.es/aviso-legal/"
      },
      {
        label: "Palabras clave",
        url: "https://www.holidayguru.es/tag/"
      }
    ],
    social: {
      label: "Sígueme",
      data: [
        {
          label: "Facebook",
          icon: "facebook",
          url: "https://www.facebook.com/Holidayguru.ES/"
        },
        {
          label: "TikTok",
          icon: "tiktok",
          url: "https://www.tiktok.com/@holidayguru"
        },
        {
          label: "Instagram",
          icon: "instagram",
          url: "https://www.instagram.com/holidayguru.es/"
        },
        {
          label: "Pinterest",
          icon: "pinterest",
          url: "https://www.pinterest.de/holidayguru_es/"
        }
      ]
    },
    newsletter: {
      label: "Regístrate en mi Newsletter",
      button: "Newsletter",
      url: "https://www.holidayguru.es/newsletter/"
    },
    app: {
      label: "Descárgate mi App gratuita",
      apple: "https://go.holidayguru.es/itunes",
      android: "https://go.holidayguru.es/googleplay"
    }
  },

  jsonLD: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Holidayguru",
    url: "https://www.holidayguru.es/",
    logo: "https://www.holidayguru.es/wp-content/uploads/2018/02/logo-1.png",
    sameAs: [
      "https://www.facebook.com/holidayguru.es/",
      "https://www.instagram.com/holidayguru.es/",
      "https://www.tiktok.com/@holidayguru",
      "https://www.pinterest.es/holidayguru_es/"
    ]
  },
  privacyManagerModalId: "547875",
  newsletter: {
    title: "Holidayguru Newsletter",
    info: "¿Quieres recibir <strong>chollos exclusivos y ofertas en primicia a tu correo</strong>? Ahorra tiempo y dinero buscando ofertas y ¡Subscríbete ahora! <br /> <br />Encontrarás:",
    listItem1: "Ofertas de viajes encontradas por los expertos de Holidayguru",
    listItem2: "Chollos con una calidad-precio ¡increíble!",
    listItem3: "Inspiración y consejos útiles para tu viaje",
    button: "Registrarse"
  },
  amadeusPackageTourSearch: {
    infoTextSingleRoom: "Todas las personas se alojarán en una habitación. Si desea una distribución de la habitación diferente, contáctanos:"
  }
}
